'use strict';

angular.module('casist.ucto', []);